import { render, staticRenderFns } from "./TheCoberturaSeguro.vue?vue&type=template&id=bddd8aae&scoped=true&"
import script from "./TheCoberturaSeguro.vue?vue&type=script&lang=js&"
export * from "./TheCoberturaSeguro.vue?vue&type=script&lang=js&"
import style0 from "./TheCoberturaSeguro.vue?vue&type=style&index=0&id=bddd8aae&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddd8aae",
  null
  
)

export default component.exports